export default "__VITE_ASSET__BNtiDFyB__"